import React from 'react';

import { Control } from 'react-hook-form';
import { observer } from 'mobx-react';
import { TitleWithDescription, LbRadioGroup } from '@infoods/lifebase-ui';

import classes from './DivisionPicker.module.scss';
import { challengeSignUpStore } from '../../../../../../../stores/challengeSignUpStore';
import { DivisionFormValues, unknownDivisionId } from '../ChooseChallengeStep.settings';

type DivisionPickerProps = {
  control: Control<DivisionFormValues>;
};

const DivisionPicker = observer(({ control }: DivisionPickerProps) => {
  const { challengePaymentInfo } = challengeSignUpStore;

  if (!challengePaymentInfo?.divisions) {
    return null;
  }

  const options = [
    {
      value: unknownDivisionId,
      label: "I don't know my division",
    },
    ...challengePaymentInfo.divisions.map((division) => ({
      value: division.id,
      label: division.name,
    })),
  ];

  return (
    <div className={classes.container}>
      <TitleWithDescription
        title="Divisions"
        description="Select the division you belong to"
      />
      <LbRadioGroup
        className={classes.radioGroup}
        control={control}
        options={options}
        name="divisionId"
        rules={{ required: 'Division is required' }}
      />
    </div>
  );
});

export { DivisionPicker };
